import {
  Component,
  computed,
  inject,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { ReportsState } from '@app/modules/reports/store/reports.state';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { ReportViewerComponent } from '@app/modules/reports/components/reports/report-viewer/report-viewer.component';
import { DocumentPreviewComponent } from '@app/modules/service-data/components/document-preview/product-inventory-item-document-preview/document-preview.component';
import { ReportsService } from '@app/modules/reports/services/reports.service';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { of, switchMap } from 'rxjs';

@Component({
  selector: 'app-report-viewer-dialog',
  imports: [TranslatePipe, ReportViewerComponent, DocumentPreviewComponent],
  templateUrl: './report-viewer-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './report-viewer-dialog.component.scss',
})
export class ReportViewerDialogComponent {
  private store = inject(Store);
  private modal = inject(NgbActiveModal);
  private reportService = inject(ReportsService);
  reportId = signal<string>(null);

  report = computed(() =>
    this.store.selectSignal(ReportsState.getReport)()(this.reportId())
  );
  reportUrl = toSignal(
    toObservable(this.report).pipe(
      switchMap((report) =>
        report?.documentUrl ? this.reportService.reportUrl(report.id) : of(null)
      )
    ),
    { initialValue: null }
  );
  downloadFileName = computed(() => this.buildDownloadFileName());

  dismiss() {
    this.modal.dismiss();
  }

  private buildDownloadFileName(): string {
    const report = this.report();
    if (!report) {
      return 'report';
    }

    const properties = Object.fromEntries(
      (report.properties ?? []).map((property) => [
        property.key,
        property.value,
      ])
    );
    const kitId = properties['KitId'];
    const firstName = report.analysisData?.patientFirstName;
    const lastName = report.analysisData?.patientLastName;

    return [kitId, firstName, lastName, report.reportType, `v${report.version}`]
      .filter((value) => !!value)
      .join('_');
  }
}
